/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * My API
 * OpenAPI spec version: 1.0.0
 */

export type PlacementRequestFeeType = typeof PlacementRequestFeeType[keyof typeof PlacementRequestFeeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlacementRequestFeeType = {
  percentage: 'percentage',
  fixed: 'fixed',
} as const;
